var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-body')
}
var staticRenderFns = []

export { render, staticRenderFns }